import React from 'react';
import BaseInput from '../../Base/BaseInput';
import BaseSelect from '../../Base/BaseSelect';
import { Vehicle } from '../../../models/VehicleModel';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../../utils/textInputSanitize';

type Props = {
  value: Vehicle;
  onChange: (v: Vehicle) => void;
  error?: string | null;
  fieldErrors?: Record<string, string>;
};

const VehicleForm: React.FC<Props> = ({ value, onChange, error, fieldErrors = {} }) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: val } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, val) });
  };

  const handleTextBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: val } = e.target;
    const next = finalizeFormTextField(name, val);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value: val } = e.target;
    onChange({ ...value, [name]: val });
  };

  return (
    <div className="vehicle-form">
      <div className="form-row">
        <div className="form-field">
          <BaseInput
            label="Marca"
            name="brand"
            value={value.brand ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            autoFocus
            maxLength={80}
            error={fieldErrors.brand}
          />
        </div>

        <div className="form-field">
          <BaseInput
            label="Patente"
            name="license_plate"
            value={value.license_plate ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            maxLength={20}
            error={fieldErrors.license_plate}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <BaseSelect
            label="Estado"
            name="status"
            value={value.status ?? 'Operativo'}
            onChange={handleSelectChange}
            options={[
              { value: 'Operativo', label: 'Operativo' },
              { value: 'En mantenimiento', label: 'En mantenimiento' },
              { value: 'Fuera de servicio', label: 'Fuera de servicio' },
            ]}
          />
          {fieldErrors.status && (
            <div className="form-error" role="alert">
              {fieldErrors.status}
            </div>
          )}
        </div>
      </div>

      {error && <div className="form-error" role="alert">{error}</div>}
    </div>
  );
};

export default VehicleForm;
